import { Injectable } from '@angular/core';
import { ICoreSchoolBlackoutLocalDto } from '@nova/types';
import { Observable } from 'rxjs';

import { UrlService } from 'app/core/http/url.service';
import { GameServerGateway } from 'app/student/game-section/services/gateways/game-server-gateway';

@Injectable({
  providedIn: 'root'
})
export class StudentTimeCheckerHttpService {
  private readonly BASE_URL = 'users';

  public constructor(private readonly gameServerGateway: GameServerGateway,
    private readonly urlService: UrlService) {
  }

  public getInfo(): Observable<ICoreSchoolBlackoutLocalDto> {
    const url: string = this.urlService.buildGameServerApiUrl(this.BASE_URL, 'in-school');
    return this.gameServerGateway.get<ICoreSchoolBlackoutLocalDto>(url);
  }
}
